///////////////////////////////////////////////////////////////////////////////////////
//                          Copyright (c) 2023 - 2023
//                           Coyote Logistics L.L.C.
//                         All Rights Reserved Worldwide
//
//WARNING:  This program (or document) is unpublished, proprietary
//property of Coyote Logistics L.L.C. and is to be maintained in strict confidence.
//Unauthorized reproduction, distribution or disclosure of this program
//(or document), or any program (or document) derived from it is
//prohibited by State and Federal law, and by local law outside of the U.S.
///////////////////////////////////////////////////////////////////////////////////////

import React from "react";

import messages from "../../../helpers/messages";

export const NoCapacityMatchLaneSummary = () => {
  return (
    <div
      data-testid="no-capacity-match-lane-summary"
      className="flex justify-center text-center items-center one-whole"
      style={{ height: window.screen.availHeight - 120 }}
    >
      <div style={{ width: "50%", maxWidth: "500px" }}>
        <p className="mb-32 no-lanes-title">
          {messages.noLanesAvailable.defaultMessage}
        </p>
      </div>
    </div>
  );
};

export default NoCapacityMatchLaneSummary;
